const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getReportSchedules(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.profileId) params.append('profileId', filters.profileId);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/report-schedules${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch report schedules');
  }
  
  return response.json();
}

export async function getReportSchedule(orgId, scheduleId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-schedules/${scheduleId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch report schedule');
  }
  
  const data = await response.json();
  return data.schedule;
}

export async function createReportSchedule(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-schedules`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create report schedule');
  }
  
  const result = await response.json();
  return result.schedule;
}

export async function updateReportSchedule(orgId, scheduleId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-schedules/${scheduleId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    throw new Error('Failed to update report schedule');
  }
  
  const result = await response.json();
  return result.schedule;
}

export async function deleteReportSchedule(orgId, scheduleId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-schedules/${scheduleId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to delete report schedule');
  }
  
  return true;
}

export async function triggerScheduledRun(orgId, scheduleId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-schedules/${scheduleId}/trigger`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to trigger scheduled run');
  }
  
  const result = await response.json();
  return result.run;
}
